export default __webpack_public_path__ + "static/media/acrchive.d81f9715.svg";